// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_z34","cls2":"CiterightPreprintReport-cls2_tvt CiterightPreprintReport-cls1_z34"};